import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaEdit, FaTrash, FaTags, FaChevronDown, FaChevronUp, FaHistory } from 'react-icons/fa';
import { toast } from 'react-toastify';
import productService from '../services/productService';

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedRow, setExpandedRow] = useState(null);

  const fetchProducts = async () => {
    try {
      const data = await productService.getAll();
      setProducts(data);
    } catch (error) {
      toast.error('Ürünler yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const toggleRow = (id) => setExpandedRow(expandedRow === id ? null : id);

  const handleDelete = async (id) => {
    if (window.confirm('Bu ürünü silmek istediğinize emin misiniz?')) {
      try {
        await productService.delete(id);
        toast.success('Ürün silindi.');
        fetchProducts();
      } catch (error) {
        toast.error('Silme işlemi başarısız.');
      }
    }
  };

  const filteredProducts = products.filter(p => 
    p.name?.toLocaleLowerCase('tr-TR').includes(searchTerm.toLocaleLowerCase('tr-TR'))
  );

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Stok & Ürünler</h2>
        <div>
          <Link to="/categories" className="btn btn-outline-secondary me-2">
            <FaTags className="me-2" /> Kategoriler
          </Link>
          <Link to="/products/new" className="btn btn-primary">
            <FaPlus className="me-2" /> Yeni Ürün Ekle
          </Link>
        </div>
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Ürün adı ile ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="table-responsive d-none d-md-block">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Ürün Adı</th>
                  <th>Kategori</th>
                  <th>Stok</th>
                  <th>Alış Fiyatı</th>
                  <th>Satış Fiyatı</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {filteredProducts.map((product) => (
                  <tr key={product.id} className={product.stock_quantity <= product.min_stock_limit ? 'table-warning' : ''}>
                    <td>
                      {product.name}
                      {product.stock_quantity <= product.min_stock_limit && (
                        <span className="badge bg-danger ms-2">Kritik Stok</span>
                      )}
                    </td>
                    <td>{product.category_name || '-'}</td>
                    <td>{product.stock_quantity} {product.unit}</td>
                    <td>{new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(product.buying_price)}</td>
                    <td>{new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(product.selling_price)}</td>
                    <td>
                      <Link to={`/products/detail/${product.id}`} className="btn btn-sm btn-outline-info me-2" title="Hareketler">
                        <FaHistory />
                      </Link>
                      <Link to={`/products/edit/${product.id}`} className="btn btn-sm btn-outline-primary me-2">
                        <FaEdit />
                      </Link>
                      <button onClick={() => handleDelete(product.id)} className="btn btn-sm btn-outline-danger">
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredProducts.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center">Kayıtlı ürün bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobil Görünüm */}
          <div className="d-md-none">
            {filteredProducts.map((product) => (
              <div className={`card mb-3 shadow-sm ${product.stock_quantity <= product.min_stock_limit ? 'border-warning' : ''}`} key={product.id}>
                <div className="card-body" onClick={() => toggleRow(product.id)} style={{ cursor: 'pointer' }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-0 fw-bold">
                        {product.name}
                        {product.stock_quantity <= product.min_stock_limit && (
                          <span className="badge bg-danger ms-2" style={{fontSize: '0.6rem'}}>Kritik</span>
                        )}
                      </h6>
                      <small className="text-muted">{product.stock_quantity} {product.unit}</small>
                    </div>
                    <div className="text-end">
                      <div className="fw-bold">{new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(product.selling_price)}</div>
                      <small className="text-muted">{expandedRow === product.id ? <FaChevronUp /> : <FaChevronDown />}</small>
                    </div>
                  </div>

                  {expandedRow === product.id && (
                    <div className="mt-3 border-top pt-3">
                      <p className="mb-1"><strong>Kategori:</strong> {product.category_name || '-'}</p>
                      <p className="mb-1"><strong>Alış Fiyatı:</strong> {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(product.buying_price)}</p>
                      <div className="d-flex justify-content-end gap-2 mt-3">
                        <Link to={`/products/detail/${product.id}`} className="btn btn-sm btn-outline-info">
                          <FaHistory /> Hareketler
                        </Link>
                        <Link to={`/products/edit/${product.id}`} className="btn btn-sm btn-outline-primary">
                          <FaEdit /> Düzenle
                        </Link>
                        <button onClick={(e) => { e.stopPropagation(); handleDelete(product.id); }} className="btn btn-sm btn-outline-danger">
                          <FaTrash /> Sil
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;